import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import IdeaEngine from "@/pages/IdeaEngine";
import Opportunities from "@/pages/Opportunities";
import CalendarEngine from "@/pages/CalendarEngine";
import Products from "@/pages/Products";
import ApprovalQueue from "@/pages/ApprovalQueue";
import Social from "@/pages/Social";
import Distribution from "@/pages/Distribution";
import Orders from "@/pages/Orders";
import StoreOrders from "@/pages/StoreOrders";
import Wholesale from "@/pages/Wholesale";
import WholesaleMargins from "@/pages/WholesaleMargins";
import WalmartMargins from "@/pages/WalmartMargins";
import RetailMargins from "@/pages/RetailMargins";
import MarketingStudio from "@/pages/MarketingStudio";
import RangeMe from "@/pages/RangeMe";
import BlogStudio from "@/pages/BlogStudio";
import Analytics from "@/pages/Analytics";
import Admin from "@/pages/Admin";
import Honorifica from "@/pages/Honorifica";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously (URL fragment) before any route/auth check
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/store" element={<Honorifica />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ideas" element={<IdeaEngine />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/calendar" element={<CalendarEngine />} />
        <Route path="/products" element={<Products />} />
        <Route path="/approval" element={<ApprovalQueue />} />
        <Route path="/social" element={<Social />} />
        <Route path="/distribution" element={<Distribution />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/store-orders" element={<StoreOrders />} />
        <Route path="/wholesale" element={<Wholesale />} />
        <Route path="/wholesale-margins" element={<WholesaleMargins />} />
        <Route path="/walmart-margins" element={<WalmartMargins />} />
        <Route path="/retail-margins" element={<RetailMargins />} />
        <Route path="/marketing" element={<MarketingStudio />} />
        <Route path="/rangeme" element={<RangeMe />} />
        <Route path="/blog" element={<BlogStudio />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
